import React from 'react';
import Reflux from 'reflux';
import {Redirect, Route} from 'react-router-dom';
import ScrollUpButton from 'react-scroll-up-button';
import User from '../helpers/user';
import Login from './login/Login';
import Header from './common/Header';
import Footer from './common/Footer';
import Company from './company/Company';
import Supplier from './supplier/Supplier';
import CustomerRules from './customer/CustomerRules';
import Customer from "./customer/Customer";

class AppComponent extends Reflux.Component {

    renderPrivateRoute = (Component) => {
        return (routeProps) => {
            if (User.isGuest()) {
                return <Redirect to="/login"/>;
            }

            // A kompatibilitás miatt ugyanúgy adjuk tovább,
            // ahogy a régi alkalmazás várja.
            return (
                <Component
                    location={routeProps}
                />
            );
        };
    };

    renderLogin = () => {
        if (!User.isGuest()) {
            return <Redirect to="/"/>;
        }

        return <Login/>;
    };

    render() {
        return (
            <div className="App">

                <Header/>

                <main className="content">

                    <Route
                        exact
                        path="/"
                        render={this.renderPrivateRoute(Company)}
                    />

                    <Route
                        exact
                        path="/companies-list"
                        render={this.renderPrivateRoute(Company)}
                    />

                    <Route
                        exact
                        path="/start/customer/:id"
                        render={this.renderPrivateRoute(Customer)}
                    />

                    <Route
                        exact
                        path="/start/supplier/:id"
                        render={this.renderPrivateRoute(Supplier)}
                    />

                    <Route
                        exact
                        path="/customer/rules/:id"
                        render={this.renderPrivateRoute(CustomerRules)}
                    />

                    <Route
                        exact
                        path="/login"
                        render={this.renderLogin}
                    />

                </main>
                <Footer/>

                <ScrollUpButton/>

            </div>
        );
    }
}

export default AppComponent;


// WEBPACK FOOTER //
// ./src/components/App.js